export const workTypeDesignTokens = {
  color: {
    canvas: "var(--work-type-color-canvas, #F8FAFC)",
    surface: "var(--work-type-color-surface, #FFFFFF)",
    surfaceMuted: "var(--work-type-color-surface-muted, #F1F5F9)",
    text: "var(--work-type-color-text, #0F172A)",
    textMuted: "var(--work-type-color-text-muted, #475569)",
    border: "var(--work-type-color-border, #E2E8F0)",
    borderStrong: "var(--work-type-color-border-strong, #CBD5E1)",
    focus: "var(--work-type-color-focus, #4F46E5)"
  },
  radius: {
    control: "10px",
    card: "12px",
    dialog: "14px",
    pill: "999px"
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px"
  },
  control: {
    height: "44px",
    compactHeight: "40px"
  },
  focus: {
    outline: "3px solid var(--work-type-color-focus, #4F46E5)",
    offset: "2px"
  },
  tone: {
    approval: {
      background: "var(--work-type-tone-approval-background, #EFF6FF)",
      text: "var(--work-type-tone-approval-text, #1D4ED8)",
      border: "var(--work-type-tone-approval-border, #BFDBFE)"
    },
    active: {
      background: "var(--work-type-tone-active-background, #F0FDF4)",
      text: "var(--work-type-tone-active-text, #15803D)",
      border: "var(--work-type-tone-active-border, #BBF7D0)"
    },
    danger: {
      background: "#FFF1F2",
      text: "#BE123C",
      border: "#FECDD3"
    },
    neutral: {
      background: "var(--work-type-tone-neutral-background, #F1F5F9)",
      text: "var(--work-type-tone-neutral-text, #475569)",
      border: "var(--work-type-tone-neutral-border, #E2E8F0)"
    },
    selected: {
      background: "var(--work-type-tone-selected-background, #EEF2FF)",
      text: "var(--work-type-tone-selected-text, #334155)",
      border: "var(--work-type-tone-selected-border, #C7D2FE)"
    }
  }
} as const;

export type WorkTypeSemanticTone = keyof typeof workTypeDesignTokens.tone;
